import { applyTokens } from "../../../utilities/applyTokens.js";
const sideSheet = (tokens) => {
    const { sideSheet } = tokens.component;
    const { core } = tokens;
    return {
        MuiDrawer: {
            defaultProps: {
                anchor: "right",
            },
            styleOverrides: {
                paper: Object.assign(Object.assign({}, applyTokens(sideSheet)), { height: "100vh", borderRadius: "unset", overflowY: "visible" }),
                root: {
                    "& .MuiBackdrop-root": {
                        opacity: "50% !important",
                        backgroundColor: core.color.gray[900].value,
                    },
                },
            },
        },
    };
};
export default sideSheet;
//# sourceMappingURL=sideSheet.js.map